import React from "react";

import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { useParams } from "react-router";
import Spin from "shared/components/Spin";
import { FOLDER_STATUS } from "shared/graphql/queries";

import View from "./View";

const Component = ({ data, refetch }) => {
  const { id } = useParams();
  const query = useQuery(FOLDER_STATUS, {
    variables: { where: { folderNum: id } },
  });

  /**
   * Fetch data handler. This a wrapper for two fetch operations:
   * <ul>
   *     <li>fetch parent data (folder info WS ), using passed `refetch` handler</li>
   *     <li>the folder-status data (folder status WS)</li>
   * </ul>
   * @returns {Promise<void>}
   * @private
   */
  const _fetchDataHandler = async () => {
    await refetch();
    await query?.refetch();
  };

  if (query.loading) {
    return <Spin />;
  }

  return (
    <View
      refetch={refetch}
      folderStatus={query?.data?.folderStatus}
      folder={data}
      fetchDataHandler={_fetchDataHandler}
    />
  );
};

Component.propTypes = {
  data: PropTypes.object.isRequired,
  refetch: PropTypes.func.isRequired,
};

export default Component;
